import React from 'react';
import MileageCard from '../MileageCard';
import { formatDate } from '../../../constants/date';

interface MileageDashboardListProps {
  data?: any[];
}

const MileageDashboardList: React.FC<MileageDashboardListProps> = ({ data }) => {


  return (
    <div className="property-listing-container">
      <h2 className="section-title">Mileage</h2>

      {(data && data?.length > 0) ? (
        <div className="properties-grid">
          {data?.map((mileage: any, index: any) => (
            <MileageCard
              key={index}
              main_category={mileage?.main_category}
              distance={mileage?.distance}
              source_name={mileage?.source_name}
              destination_name={mileage?.destination_name}
              sub_activity={mileage?.sub_activity}
              property_name={mileage?.property?.name}
              date={formatDate(mileage?.date)}
            />
          ))}
        </div>
      ) : (
        <p className="text-center w-100 py-4">No data found.</p>
      )}

    </div>
  );
};

export default MileageDashboardList;